import { TAGS } from "../constants";
import {
  PatientCoupon,
  PatientCouponInsert,
  PatientCouponUpdate,
} from "../types";
import { api } from "./api";

export const patientCouponsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    addPatientCoupon: builder.mutation<PatientCoupon[], PatientCouponInsert>({
      query: (body) => ({
        url: `/api/patient-coupons`,
        method: "POST",
        body,
      }),

      invalidatesTags: [TAGS.PATIENT_COUPONS],
    }),
    updatePatientCoupon: builder.mutation<
      PatientCoupon,
      { id: number; body: PatientCouponUpdate }
    >({
      query: ({ id, body }) => ({
        url: `/api/patient-coupons/${id}`,
        method: "PUT",
        body,
      }),

      invalidatesTags: [TAGS.PATIENT_COUPONS],
    }),
  }),
});

export const { useAddPatientCouponMutation, useUpdatePatientCouponMutation } =
  patientCouponsApi;
